import service from './index';
export enum EUserRoleCode {
  SUPER_ADMIN = 'SUPER_ADMIN',
  // 小冰运营
  OPERATOR = 'OPERATOR',
  // 服务商
  SERVICE_PROVIDER = 'SERVICE_PROVIDER',
  // 代理商
  AGENT = 'AGENT',
}
export enum EUserRoleId {
  SUPER_ADMIN = '1',
  // 小冰运营
  OPERATOR = '2',
  // 服务商
  SERVICE_PROVIDER = '3',
  // 代理商
  AGENT = '4',
}
export const roleCodeToNameMap: Record<EUserRoleCode, string> = {
  [EUserRoleCode.SUPER_ADMIN]: '超级管理员',
  [EUserRoleCode.OPERATOR]: '小冰运营',
  [EUserRoleCode.SERVICE_PROVIDER]: '服务提供商',
  [EUserRoleCode.AGENT]: '代理商',
};
export const roleCodeOptions = Object.entries(roleCodeToNameMap).map(([value, label]) => ({ value, label }));

export const roleIdToNameMap: Record<EUserRoleId, string> = {
  [EUserRoleId.SUPER_ADMIN]: '超级管理员',
  [EUserRoleId.OPERATOR]: '小冰运营',
  [EUserRoleId.SERVICE_PROVIDER]: '服务提供商',
  [EUserRoleId.AGENT]: '代理商',
};
export const roleIdOptions = [
  { value: EUserRoleId.SUPER_ADMIN, label: roleIdToNameMap[EUserRoleId.SUPER_ADMIN] },
  { value: EUserRoleId.OPERATOR, label: roleIdToNameMap[EUserRoleId.OPERATOR] },
  { value: EUserRoleId.SERVICE_PROVIDER, label: roleIdToNameMap[EUserRoleId.SERVICE_PROVIDER] },
  { value: EUserRoleId.AGENT, label: roleIdToNameMap[EUserRoleId.AGENT] },
];
/**
 * 用户状态
 */
export enum EUserStatus {
  Deleted = 'DELETED',
  Locked = 'LOCKED',
  Normal = 'NORMAL',
}
/**
 * RoleRes，角色信息
 */
export interface RoleRes {
  /**
   * 角色编码
   */
  roleCode?: EUserRoleCode | string;
  /**
   * 角色id
   */
  roleId?: number;
  /**
   * 角色名称
   */
  roleName?: string;
  [property: string]: any;
}

/**
 * IUserInfo
 */
export interface IUserInfo {
  /**
   * 邮箱
   */
  email: string;
  /**
   * 昵称
   */
  nickname: string;
  /**
   * 手机号
   */
  phone?: string;
  /**
   * 状态
   */
  status?: EUserStatus;
  /**
   * 角色
   */
  roles?: RoleRes[];
  /**
   * 角色标识（与 /user/auth/me 返回保持一致）
   */
  roleKey?: string;
  permissions?: string[];
  /**
   * 服务提供商 id
   */
  serviceProviderId?: number;
  /**
   * 服务提供商名称
   */
  serviceProviderName?: string;
  /**
   * 用户 id
   */
  userId?: number;
  [property: string]: any;
}

export const userApi = {
  login: (data: { email: string; password: string }) => service.post<IUserInfo>('/user/auth/login', data),
  getUserInfo: () => service.get<IUserInfo>('/user/auth/me'),
  logout: () => service.post('/user/auth/logout'),
  modifyPwd: (data: { oldPassword: string; newPassword: string }) => service.post('/sys/user/reset/password', data),
  getClientSsoTicket: (data: { companyId: string }) => service.post<{ redirectUrl?: string }>('/user/auth/client/sso-ticket', data),
};

/**
 * UserVo，用户权限信息
 */
export interface UserVo {
  /**
   * 创建时间
   */
  createTime?: Date;
  /**
   * 用户邮箱
   */
  email?: string;
  /**
   * 用户昵称
   */
  nickname?: string;
  /**
   * 用户密码
   */
  password?: string;
  /**
   * 用户角色
   */
  roles?: RoleRes[];
  /**
   * 用户状态
   */
  status?: EUserStatus;
  /**
   * 更新时间
   */
  updateTime?: Date;
  /**
   * 用户id
   */
  userId?: number;
  [property: string]: any;
}

export interface GCUserVo {
  createTime?: Date;
  email?: string;
  mobile?: string;
  remark?: string;
  roleId?: string | number;
  roleName?: string;
  roles?: RoleRes[];
  status?: number;
  username?: string;
  accountName?: string;
  nickname?: string;
  userId?: number | string;
  id?: number | string;
  [property: string]: any;
}

export const userManagerApi = {
  list: (data: { pageIndex: number; pageSize: number; search?: string; status?: string; roleCodes?: EUserRoleCode[] }) =>
    service.post<List<UserVo>>('/user/page', data),
  get: (userId: number) => service.get<UserVo>(`/user/info?userId=${userId}`),
  roles: () => service.get<RoleRes[]>('/role/roles'),
  create: (data: { email: string; nickname: string; password: string; roleIds: Array<string | number> }) =>
    service.post('/user/create', data),
  update: (data: {
    userId: number;
    nickname?: string;
    email?: string;
    password?: string;
    roleIds?: Array<string | number>;
    status?: EUserStatus;
  }) => service.post('/user/update', data),
  lockUser: (userIds: number[]) => service.post('/user/lock', { userIds }),
  unlockUser: (userIds: number[]) => service.post('/user/unlock', { userIds }),
};

export const gcUserApi = {
  list: (data: { companyId?: string; pageIndex: number; pageSize: number }) => service.post<List<GCUserVo>>('/gc/user/page', data),
  roles: () => service.get<RoleRes[]>('/gc/user/roles'),
  create: (data: {
    companyId?: string;
    username: string;
    email: string;
    passwordHash: string;
    roleIds: Array<string | number>;
  }) =>
    service.post('/gc/user/create', data),
  update: (data: {
    userId: number | string;
    username: string;
    email?: string;
    mobile?: string;
    status: number;
    nickname?: string;
    remark?: string;
    roleIds: Array<string | number>;
  }) => service.post('/gc/user/update', data),
  delete: (data: { userId?: number | string; id?: number | string }) =>
    service.post('/gc/user/delete', {
      ...data,
      userIds: data.userId || data.id ? [data.userId ?? data.id] : undefined,
    }),
  resetPassword: (data: { userId: number | string; newPassword: string }) => service.post('/gc/user/password/reset', data),
};
